import React from 'react'
import PropTypes from 'prop-types'

class DateTd extends React.Component {
  render() {
    return(
      <td className={this.props.fieldClassName}>
        {this.props.fieldValue ? (
          <span className={this.props.fieldInsideClassName}>
            {moment(this.props.fieldValue).format(this.props.fieldFormat)}
          </span>
        ) : (
          <span className={this.props.fieldInsideClassName}>
            -
          </span>
        )}
      </td>
    )
  }
}

DateTd.propTypes = {
  fieldValue: PropTypes.string,
  fieldFormat: PropTypes.string,
  fieldClassName: PropTypes.string,
  fieldInsideClassName: PropTypes.string
}

export default DateTd
